import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f91d0f18"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "media-info"
};
const _hoisted_2 = {
  class: "movie_media"
};
const _hoisted_3 = {
  style: {
    "margin-bottom": "24px"
  }
};
const _hoisted_4 = {
  class: "media"
};
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "body-list"
};
const _hoisted_7 = {
  class: "coding"
};
const _hoisted_8 = {
  class: "transfer"
};
const _hoisted_9 = {
  class: "ratio"
};
const _hoisted_10 = {
  class: "url-warp"
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_12 = {
  class: "delete"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "movie_subtitle",
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_16 = {
  class: "subtitle"
};
const _hoisted_17 = {
  class: "info"
};
const _hoisted_18 = {
  class: "body-list"
};
const _hoisted_19 = {
  class: "language"
};
const _hoisted_20 = {
  class: "url-warp"
};
const _hoisted_21 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "tv_media"
};
const _hoisted_24 = {
  class: "media"
};
const _hoisted_25 = {
  class: "info"
};
const _hoisted_26 = {
  class: "body-list"
};
const _hoisted_27 = {
  class: "coding"
};
const _hoisted_28 = {
  class: "transfer"
};
const _hoisted_29 = {
  class: "ratio"
};
const _hoisted_30 = {
  class: "url-warp"
};
const _hoisted_31 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_32 = {
  class: "delete"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "tv_subtitle"
};
const _hoisted_36 = {
  class: "subtitle"
};
const _hoisted_37 = {
  class: "info"
};
const _hoisted_38 = {
  class: "body-list"
};
const _hoisted_39 = {
  class: "language"
};
const _hoisted_40 = {
  class: "url-warp"
};
const _hoisted_41 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_42 = {
  class: "delete"
};
const _hoisted_43 = ["onClick"];
import { nextTick, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { getArrByReduce } from "@/utils/tools";
import { getTextWidth, isEmptyArray } from '@/utils';
import { validatorNonNull } from '@/utils/validate';
import { useBroadCastList } from '@/utils/cacheData';
import { handleCopy } from '@/utils/clipboard';
import { getSysDictListApi } from '@/api/live';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // mediaContentList索引
    c_index: {
      type: Number,
      default: 0
    },
    seasonIndex: {
      type: Number,
      default: 0
    },
    formData: {
      type: Array,
      default: []
    },
    programType: {
      type: String,
      default: 'movie'
    },
    checkedList: {
      type: Array,
      default: []
    }
  },
  emits: ['add-media', 'delete-media-item', 'add-subtitle', 'delete-subtitle-item', 'search-subtitle', 'add-mediaInfo', 'update:checkedList'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const transferOptions = ref([]);
    const transferLoading = ref(false);
    watch(() => props.checkedList, val => {
      emit('update:checkedList', val);
    }, {
      immediate: true,
      deep: true
    });

    const isChecked = index => {
      const idx = props.checkedList.indexOf(index);
      return idx === -1 ? false : true;
    };

    const handleCheckChange = index => {
      const idx = props.checkedList.indexOf(index);

      if (idx > -1) {
        emit('update:checkedList', props.checkedList.splice(idx, 1));
      } else {
        emit('update:checkedList', props.checkedList.push(index));
      }
    };

    const languageOptions = inject('languageOptions');
    const selectOptions = computed(() => {
      const options = [];
      languageOptions.value.forEach(item => {
        options.push({ ...item,
          disabled: false
        });
      });
      return options;
    }); // 已选的语言加上禁用

    const addDisabledForOptions = val => {
      if (!isEmptyArray(val)) {
        let ids = getArrByReduce(val, 'audioLanguage');
        selectOptions.value.forEach(item => {
          item.disabled = ids.includes(item['label']) ? true : false;
        });
      }
    };

    watch(() => [...props.formData], val => {
      addDisabledForOptions(val);
    }, {
      immediate: true,
      deep: true
    });
    const searchConfig = reactive({
      formList: [{
        label: '影片名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入影片名称',
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入影片名称'),
          trigger: 'blur'
        }],
        controller: (data, row, config) => {
          return props.programType === 'movie' ? true : false;
        },
        style: {
          minWidth: '120px'
        }
      }, {
        label: '语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        placeholder: '请选择语言',
        filterable: true,
        valueKey: 'label',
        list: selectOptions,
        rules: [{
          required: true,
          message: '请选择语言',
          trigger: 'change'
        }],
        change: val => {
          addDisabledForOptions(props.formData);
        }
      } // {
      //     label: '排序',
      //     prop: 'sort',
      //     widgetType: 'input',
      //     placeholder: '请输入序号',
      // },
      ]
    });

    const validateUrl = (rule, value, callback) => {
      const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;

      if (value == undefined || value === '') {
        callback(new Error(t('请输入URL')));
      } else if (!reg.test(value)) {
        callback(new Error(t('URL必须以 (https|http|ftp|rtsp|mms)://) 开头')));
      } else if (value.length > 500) {
        callback(new Error(t('URL的长度不能超过500')));
      } else {
        callback();
      }
    };

    const validateUrlNotReq = (rule, value, callback) => {
      console.log('value======', value, '| fullField======', rule.fullField, '| field======', rule.field); // 非必填：空值直接放行，避免 value.length 访问 undefined 抛错

      if (value === undefined || value === null || value === '') {
        callback();
        return;
      }

      const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;

      if (!reg.test(value)) {
        callback(new Error(t('URL必须以 (https|http|ftp|rtsp|mms)://) 开头')));
      } else if (value.length > 500) {
        callback(new Error(t('URL的长度不能超过500')));
      } else {
        callback();
      }
    };

    const validateLanguage = (rule, value, callback, subtitle) => {
      if (subtitle && !value) {
        callback(new Error(t('请选择语言')));
      } else {
        callback();
      }
    }; // 获取分辨率


    const getBroadCastList = async () => {
      const res = await useBroadCastList();
      options.data2 = res;
    };

    const options = reactive({
      data1: [{
        value: 'H264',
        label: 'H.264'
      }, {
        value: 'H265',
        label: 'H.265'
      }],
      data2: []
    });

    const addMedia = index => {
      emit('add-media', index);
    }; // 删除节目 seasonIndex：剧集季的索引


    const deleteMediaItem = (index, mediaIndex, seasonIndex) => {
      emit('delete-media-item', index, mediaIndex, seasonIndex);
    };

    const addSubtitle = index => {
      emit('add-subtitle', index);
    }; // 删除字幕 seasonIndex：剧集季的索引


    const deleteSubtitleItem = (index, subtitleIndex, seasonIndex) => {
      emit('delete-subtitle-item', index, subtitleIndex, seasonIndex);
    };

    const searchSubtitle = () => {
      emit('search-subtitle');
    }; // 传输协议懒加载选项


    const onVisibleChange = isVisible => {
      if (isVisible && transferOptions.value.length === 0) {
        transferLoading.value = true;
        getTransferOptions();
        transferLoading.value = false;
      }
    };

    const getTransferOptions = async () => {
      try {
        const {
          code,
          data
        } = await getSysDictListApi('vod_transfer_protocol');

        if (code == 0) {
          transferOptions.value = data ? data : [];
        }
      } catch (error) {}
    }; // 复制value


    const copyValue = (value, event) => {
      handleCopy(value, event);
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      nextTick(() => {
        const target = e.target;

        if (target.tagName == 'INPUT') {
          const width = getTextWidth(target.value, {
            fontSize: '14px'
          });
          tipDisabled.value = target.offsetWidth < width;
        }
      });
    };

    onMounted(() => {
      getBroadCastList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_MPopper = _resolveComponent("MPopper");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.programType === 'movie' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formData[__props.c_index].mediaContentList, (media, mediaIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "body",
          key: mediaIndex
        }, [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_form_item, {
          prop: `mediaList.${__props.c_index}.mediaContentList[${mediaIndex}].videoCode`,
          rules: [{
            required: true,
            message: _ctx.$t('请选择编码标准'),
            trigger: 'change'
          }],
          label: _ctx.$t('编码标准')
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: media.isOnline,
            clearable: "",
            modelValue: media.videoCode,
            "onUpdate:modelValue": $event => media.videoCode = $event,
            placeholder: _ctx.$t('请选择编码标准')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.data1, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])]),
          _: 2
        }, 1032, ["prop", "rules", "label"])]), _createElementVNode("span", _hoisted_8, [_createVNode(_component_el_form_item, {
          prop: `mediaList.${__props.c_index}.mediaContentList[${mediaIndex}].transferProtocol`,
          label: _ctx.$t('传输协议'),
          rules: [{
            required: false
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: media.isOnline,
            clearable: "",
            modelValue: media.transferProtocol,
            "onUpdate:modelValue": $event => media.transferProtocol = $event,
            onVisibleChange: onVisibleChange,
            loading: transferLoading.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.label
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "loading"])]),
          _: 2
        }, 1032, ["prop", "label"])]), _createElementVNode("span", _hoisted_9, [_createVNode(_component_el_form_item, {
          prop: `mediaList.${__props.c_index}.mediaContentList[${mediaIndex}].videoResolution`,
          label: _ctx.$t('分辨率'),
          rules: [{
            required: true,
            message: _ctx.$t('请选择分辨率'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: media.isOnline,
            clearable: "",
            modelValue: media.videoResolution,
            "onUpdate:modelValue": $event => media.videoResolution = $event,
            placeholder: _ctx.$t('请选择分辨率')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.data2, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.broadCastType,
                value: item.broadCastType
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])]),
          _: 2
        }, 1032, ["prop", "label", "rules"])]), _createElementVNode("span", _hoisted_10, [_createVNode(_component_el_form_item, {
          prop: `mediaList.${__props.c_index}.mediaContentList[${mediaIndex}].playUrl`,
          label: "URL",
          rules: [{
            required: true,
            trigger: 'blur',
            validator: validateUrl
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", {
              style: {
                "width": "100%"
              },
              onMouseover: showTextTip
            }, [_createVNode(_component_el_input, {
              onFocus: _cache[0] || (_cache[0] = $event => tipDisabled.value = false),
              disabled: media.isOnline,
              modelValue: media.playUrl,
              "onUpdate:modelValue": $event => media.playUrl = $event,
              modelModifiers: {
                trim: true
              },
              placeholder: _ctx.$t('请输入URL')
            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])], 32)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, _toDisplayString(media.playUrl), 1), _createVNode(_component_el_button, {
              class: "cms-op-btn-non-focus",
              onClick: $event => copyValue(media.playUrl, $event),
              style: {
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["disabled"])]),
          _: 2
        }, 1032, ["prop", "rules"])]), _createElementVNode("span", _hoisted_12, [__props.c_index == 0 && __props.formData[__props.c_index].mediaContentList.length > 1 && !media.isOnline ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: $event => deleteMediaItem(__props.c_index, mediaIndex)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_13)) : _createCommentVNode("", true), __props.c_index > 0 && !media.isOnline ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: $event => deleteMediaItem(__props.c_index, mediaIndex)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_14)) : _createCommentVNode("", true)])]);
      }), 128))])])])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formData[__props.c_index].subtitleList, (subtitle, subtitleIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "body",
          key: subtitleIndex
        }, [_createElementVNode("span", _hoisted_19, [_createVNode(_component_el_form_item, {
          prop: `mediaList.${__props.c_index}.subtitleList[${subtitleIndex}].language`,
          label: _ctx.$t('字幕语言'),
          rules: [{
            message: _ctx.$t('请选择语言'),
            trigger: 'change',
            validator: (rule, value, callback) => validateLanguage(rule, value, callback, subtitle.value)
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            filterable: "",
            modelValue: subtitle.language,
            "onUpdate:modelValue": $event => subtitle.language = $event,
            placeholder: _ctx.$t('请选择语言')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
          _: 2
        }, 1032, ["prop", "label", "rules"])]), _createElementVNode("span", _hoisted_20, [_createVNode(_component_el_form_item, {
          rules: [{
            required: false,
            trigger: 'blur',
            validator: validateUrlNotReq
          }],
          label: "URL",
          prop: `mediaList.${__props.c_index}.subtitleList[${subtitleIndex}].filePath`
        }, {
          default: _withCtx(() => [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", {
              style: {
                "width": "100%"
              },
              onMouseover: showTextTip
            }, [_createVNode(_component_el_input, {
              onFocus: _cache[1] || (_cache[1] = $event => tipDisabled.value = false),
              modelValue: subtitle.filePath,
              "onUpdate:modelValue": $event => subtitle.filePath = $event,
              modelModifiers: {
                trim: true
              },
              placeholder: _ctx.$t('请输入URL')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])], 32)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", null, _toDisplayString(subtitle.filePath), 1), _createVNode(_component_el_button, {
              class: "cms-op-btn-non-focus",
              onClick: $event => copyValue(subtitle.filePath, $event),
              style: {
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["disabled"])]),
          _: 2
        }, 1032, ["rules", "prop"])]), _createElementVNode("span", {
          class: "delete",
          onClick: $event => deleteSubtitleItem(__props.c_index, subtitleIndex)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_22)]);
      }), 128))])])])])])], 64)) : _createCommentVNode("", true), __props.programType === 'tv_series' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formData[0].mediaContentList, (media, mediaIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "body",
          key: mediaIndex
        }, [_createElementVNode("span", _hoisted_27, [_createVNode(_component_el_form_item, {
          prop: `tvSeasonList.${__props.seasonIndex}.tvEpisodesList.${__props.c_index}.mediaContentList[${mediaIndex}].videoCode`,
          label: _ctx.$t('编码标准'),
          rules: [{
            required: true,
            message: _ctx.$t('请选择编码标准'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: media.isOnline,
            clearable: "",
            modelValue: media.videoCode,
            "onUpdate:modelValue": $event => media.videoCode = $event,
            placeholder: _ctx.$t('请选择编码标准')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.data1, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])]),
          _: 2
        }, 1032, ["prop", "label", "rules"])]), _createElementVNode("span", _hoisted_28, [_createVNode(_component_el_form_item, {
          prop: `tvSeasonList.${__props.seasonIndex}.tvEpisodesList.${__props.c_index}.mediaContentList[${mediaIndex}].transferProtocol`,
          label: _ctx.$t('传输协议'),
          rules: [{
            required: false
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: media.isOnline,
            clearable: "",
            modelValue: media.transferProtocol,
            "onUpdate:modelValue": $event => media.transferProtocol = $event,
            onVisibleChange: onVisibleChange,
            loading: transferLoading.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.label
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "loading"])]),
          _: 2
        }, 1032, ["prop", "label"])]), _createElementVNode("span", _hoisted_29, [_createVNode(_component_el_form_item, {
          prop: `tvSeasonList.${__props.seasonIndex}.tvEpisodesList.${__props.c_index}.mediaContentList[${mediaIndex}].videoResolution`,
          label: _ctx.$t('分辨率'),
          rules: [{
            required: true,
            message: _ctx.$t('请选择分辨率'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: media.isOnline,
            clearable: "",
            modelValue: media.videoResolution,
            "onUpdate:modelValue": $event => media.videoResolution = $event,
            placeholder: _ctx.$t('请选择分辨率')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.data2, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.broadCastType,
                value: item.broadCastType
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])]),
          _: 2
        }, 1032, ["prop", "label", "rules"])]), _createElementVNode("span", _hoisted_30, [_createVNode(_component_el_form_item, {
          prop: `tvSeasonList.${__props.seasonIndex}.tvEpisodesList.${__props.c_index}.mediaContentList[${mediaIndex}].playUrl`,
          label: "URL",
          rules: [{
            required: true,
            trigger: 'blur',
            validator: validateUrl
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", {
              style: {
                "width": "100%"
              },
              onMouseover: showTextTip
            }, [_createVNode(_component_el_input, {
              onFocus: _cache[2] || (_cache[2] = $event => tipDisabled.value = false),
              disabled: media.isOnline,
              modelValue: media.playUrl,
              "onUpdate:modelValue": $event => media.playUrl = $event,
              modelModifiers: {
                trim: true
              },
              placeholder: _ctx.$t('请输入URL')
            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])], 32)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", null, _toDisplayString(media.playUrl), 1), _createVNode(_component_el_button, {
              class: "cms-op-btn-non-focus",
              onClick: $event => copyValue(media.playUrl, $event),
              style: {
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["disabled"])]),
          _: 2
        }, 1032, ["prop", "rules"])]), _createElementVNode("span", _hoisted_32, [__props.c_index === 0 && mediaIndex > 0 && !media.isOnline ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: $event => deleteMediaItem(__props.c_index, mediaIndex, __props.seasonIndex)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_33)) : _createCommentVNode("", true), __props.c_index > 0 && !media.isOnline ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: $event => deleteMediaItem(__props.c_index, mediaIndex, __props.seasonIndex)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_34)) : _createCommentVNode("", true)])]);
      }), 128))])])])])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formData[0].subtitleList, (subtitle, subtitleIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "body",
          key: subtitleIndex
        }, [_createElementVNode("span", _hoisted_39, [_createVNode(_component_el_form_item, {
          prop: `tvSeasonList.${__props.seasonIndex}.tvEpisodesList.${__props.c_index}.subtitleList[${subtitleIndex}].language`,
          label: _ctx.$t('字幕语言'),
          "label-width": "130px",
          rules: [{
            message: _ctx.$t('请选择语言'),
            trigger: 'change',
            validator: (rule, value, callback) => validateLanguage(rule, value, callback, subtitle.value)
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: subtitle.isOnline,
            filterable: "",
            modelValue: subtitle.language,
            "onUpdate:modelValue": $event => subtitle.language = $event,
            placeholder: _ctx.$t('请选择语言')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])]),
          _: 2
        }, 1032, ["prop", "label", "rules"])]), _createElementVNode("span", _hoisted_40, [_createVNode(_component_el_form_item, {
          rules: [{
            required: false,
            trigger: 'blur',
            validator: validateUrlNotReq
          }],
          label: "URL",
          prop: `tvSeasonList.${__props.seasonIndex}.tvEpisodesList.${__props.c_index}.subtitleList[${subtitleIndex}].filePath`
        }, {
          default: _withCtx(() => [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", {
              style: {
                "width": "100%"
              },
              onMouseover: showTextTip
            }, [_createVNode(_component_el_input, {
              onFocus: _cache[3] || (_cache[3] = $event => tipDisabled.value = false),
              disabled: subtitle.isOnline,
              modelValue: subtitle.filePath,
              "onUpdate:modelValue": $event => subtitle.filePath = $event,
              modelModifiers: {
                trim: true
              },
              placeholder: _ctx.$t('请输入URL')
            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])], 32)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", null, _toDisplayString(subtitle.filePath), 1), _createVNode(_component_el_button, {
              class: "cms-op-btn-non-focus",
              onClick: $event => copyValue(subtitle.filePath, $event),
              style: {
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["disabled"])]),
          _: 2
        }, 1032, ["rules", "prop"])]), _createElementVNode("span", _hoisted_42, [!subtitle.isOnline ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: $event => deleteSubtitleItem(__props.c_index, subtitleIndex, __props.seasonIndex)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_43)) : _createCommentVNode("", true)])]);
      }), 128))])])])])])], 64)) : _createCommentVNode("", true)]);
    };
  }

});